
import * as types from "../constants/action-types";
import Sorter from '../utils/sorter';

export default function companyReducer(state = [], action) {
  
    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.CREATE_COMPANY_SUCCESS:
            var result = [...state, Object.assign({}, action.company)];
            return Sorter.sort(result,'name');
        case types.GET_COMPANY_SUCCESS:
            var result = [...state.filter(company => company.companyId !== action.company.companyId), Object.assign({}, action.company)];
            return Sorter.sort(state,'name');
        case types.UPDATE_COMPANY_SUCCESS:
            var result = [...state.filter(company => company.companyId !== action.company.companyId), Object.assign({}, action.company)];
            return Sorter.sort(result,'name');
        case types.LOAD_COMPANY_SUCCESS:
            return Sorter.sort(action.items,'name');
        case types.REMOVE_COMPANY_SUCCESS:
            var result = state.filter(company => company.companyId !== action.item);
            return Sorter.sort(result,'name');
        
        default:
            return state;
    };
};


